<template>
  <div class="content-editor">
    <h2 style="margin-bottom: 20px;">
      內容編輯器

      <el-dropdown @command="useTemplate">
        <span class="el-dropdown-link el-blue">
          套用範本<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(template, idx) in $store.state.contentTemplate.list"
            :key="`template-list-${idx}`"
            :command="template.ID">
            {{template.Name}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </h2>

    <draggable v-model="mDatas"
      @change="onDataChanged"
      handle=".drag-icon">
      <content-editor-block
        v-for="(data,idx) in mDatas"
        :key="'data-'+data.id"
        v-model="mDatas[idx]"
        :index="idx"
        :is-sub-block="false"
        removable
        sortable
        @input="onDataChanged"
        @remove="removeBlock(idx)"/>
    </draggable>

    <div>
      <el-button v-show="!isActionsShown" type="primary" icon="el-icon-plus" circle @click="isActionsShown=true"></el-button>
      <el-button v-show="isActionsShown" type="primary" icon="el-icon-arrow-left" circle @click="isActionsShown=false"></el-button>
      <span class="actions" v-show="isActionsShown">

        <el-tooltip v-for="entityInfo in Entities" :key="`content-editor-button-add-entity-${entityInfo.name}`"
          class="item" effect="dark" :content="entityInfo.hint" placement="top">
          <el-button @click="addBlock(entityInfo)" circle :icon="entityInfo.icon">
            <span v-if="entityInfo.title" style="display:block;width:14px;">{{entityInfo.title}}</span>
          </el-button>
        </el-tooltip>

      </span>
    </div>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Entity from '@/utils/content-editor/entities.js'
import ContentEditorBlock from '@/utils/content-editor/components/ContentEditorBlock.vue'
export default {
  components: {
    ContentEditorBlock,
    draggable
  },
  props: {
    value: {
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      mValue: [], // should be json string
      mDatas: [], // should be json array
      isActionsShown: false,
      mRandomID: 0
    }
  },
  computed: {
    Entities () {
      return Entity.all
    }
  },
  methods: {
    addBlock (entityInfo) {
      this.mDatas.push(new entityInfo.Class(++this.mRandomID))
      this.onNewBlockAdded()
    },
    onNewBlockAdded () {
      this.isActionsShown = false

      this.$nextTick(() => {
        var scrollableEls = document.getElementsByClassName('el-tabs__content')
        for (var i = scrollableEls.length - 1; i >= 0; --i) {
          scrollableEls[i].scrollTo(0, scrollableEls[i].scrollHeight)
        }
      })
      this.onDataChanged()
    },
    onDataChanged () {
      this.$emit('input', JSON.parse(JSON.stringify(this.mDatas)))
    },
    useTemplate (id) {
      if (
        this.mDatas.length <= 0 ||
        window.confirm('使用內容範本將覆蓋原本的內容，確定嗎?')
      ) {
        let template = this.$store.state.contentTemplate.list.find(
          o => Number(o.ID) === Number(id)
        )
        this.mDatas = JSON.parse(template.Contents)
        for (var data of this.mDatas) {
          data.id = ++this.mRandomID
        }
        this.onDataChanged()
      }
    },
    removeBlock (idx) {
      this.mDatas.splice(idx, 1)
      this.onDataChanged()
    }
  },
  created () {
    this.mValue = this.value
    this.mDatas = this.mValue
    for (var data of this.mDatas) {
      this.mRandomID = Math.max(this.mRandomID, parseInt(data.id) || 0)
    }
  },
  watch: {
    value: {
      handler () {
        this.mValue = this.value
        this.mDatas = this.mValue
      },
      deep: true
    }
  }
}
</script>
